module.exports = __webpack_public_path__ + "static/media/PRENAT.28d8f017.svg";